/**
 * 全局"未保存变更"守卫（2026-10-14）
 *
 * 用途：新建/详情页有未保存的附件变动时，跳菜单/换页/关浏览器要弹提示。
 * 由于项目用 <BrowserRouter>（非 data router），useBlocker 不可用，
 * 故用全局单例 + 菜单点击拦截 + beforeunload 组合实现。
 *
 * 2026-10-14 补充（邢先生要求）：确认离开后，把该用户的暂存区清空
 * （没保存档案就不该留附件；否则下次进入又看到一堆旧文件、无从上手）。
 * 通过注册 onDiscard 回调实现：确认离开 → 调用回调清空暂存。
 */
import api from './api';

let dirty = false;
// ⭐ 2026-10-20：文案改为通用（现在不只附件，表单字段也算未保存）
let message = '当前有未保存的修改，离开将丢失。确定离开吗？';
let discardHandler = null;   // 由页面注册：无参 async 函数，负责清空暂存

export function setDirty(v, msg) {
  dirty = !!v;
  if (msg) message = msg;
}

export function isDirty() {
  return dirty;
}

// 页面注册"放弃时清理"回调（组件卸载时传 null 注销）
export function setDiscardHandler(fn) {
  discardHandler = fn;
}

// 执行放弃清理（清空暂存）。失败静默。
export function runDiscard() {
  try {
    if (typeof discardHandler === 'function') {
      Promise.resolve(discardHandler()).catch(() => {});
    }
  } catch (_) {
    /* ignore */
  }
  dirty = false;
}

// 菜单/标签跳转前调用：返回 true 表示放行；确认离开时顺带清空暂存
export function confirmLeave() {
  if (!dirty) return true;
  // eslint-disable-next-line no-alert
  const ok = window.confirm(message);
  if (ok) {
    runDiscard();
  }
  return ok;
}
